import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import axios from "axios";
import 'quill/dist/quill.snow.css';
import GeneralRequestHelper from '../../../../../Helpers/GeneralRequestHelper';
import { useParams } from 'react-router-dom';

// Yeni oluşturduğumuz component'leri dahil ediyoruz
import SingleEducationalForm from "./SingleEducationalForm";
import AddCourseModal from "./AddCourseModal";
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminEditUserEducational = () => {
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const { user } = useAuth();
    const [msg, setMsg] = useState("");

    const [courses, setCourses] = useState([]);
    const [allsubjects, setAllSubjects] = useState([]);

    const [showAddCourseModal, setShowAddCourseModal] = useState(false);
    const [userEducationals, setUserEducationals] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const params = useParams();

    const getAuthHeaders = () => ({
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    });

    const GetCourses = async () => {
        try {
            const res = await GeneralRequestHelper("/api/admin/CourseManager/GetCourses", "get", "", user.token);
            if (res.status === 200 && res.data['success']) {
                const activeCourses = (res.data?.data || [])
                    .filter((item) => item?.isDeleted === false && item?.isActive)
                    .map((item) => ({
                        id: item.id,
                        courseName: item.courseName,
                        courseDesc: item.courseDesc,
                        sortId: item.sortId
                    }))
                    .sort((a, b) => a.sortId - b.sortId);
                setCourses(activeCourses);
            } else {
                setMsg(res.data['message']);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    const GetAllSubjects = async () => {
        try {
            const res = await GeneralRequestHelper("/api/admin/SubjectManager/GetList", "get", "", user.token);
            if (res.status === 200 && res.data['success']) {
                const activeSubjects = (res.data?.data || [])
                    .filter((item) => item?.isDeleted === false && item?.isActive)
                    .map((item) => ({
                        id: item.id,
                        subjectName: item.subjectName,
                        sortId: item.sortId
                    }));
                setAllSubjects(activeSubjects);
            } else {
                setMsg(res.data['message']);
            }
        } catch (err) {
            setMsg(err.message);
        }
    };

    const GetUserById = async () => {
        try {
            const res = await axios({
                method: 'GET',
                url: `${API_BASE_URL}/admin/User/GetUserById`,
                headers: getAuthHeaders(),
                params: { userId: params['id'] }
            });

            if (res.status === 200 && res.data?.success) {
                const data = res.data?.data || {};
                setUserInfo(data?.user || null);
                setUserEducationals(data?.educationals || []);
            } else {
                setMsg(res.data?.message || "Kullanıcı bilgisi alınamadı.");
            }
        } catch (err) {
            setMsg(err?.message || "Kullanıcı bilgisi alınamadı.");
        }
    };

    const handleOpenAddCourseModal = () => {
        setShowAddCourseModal(true);
    };

    const toPlainOptionLabel = (str = "") =>
        str
            .replace(/<\s*sup\s*>/gi, "")
            .replace(/<\s*\/\s*sup\s*>/gi, "");

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await Promise.all([
                GetCourses(),
                GetAllSubjects(),
                GetUserById()
            ]);
            setLoading(false);
        };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {/* Uyarı Mesajları */}
            {userEducationals.length === 0 && (
                <div className="alert alert-warning d-flex justify-content-between align-items-center flex-wrap gap-2" role="alert">
                    <div><strong>Uyarı:</strong> Üyenin henüz hiç kursu yok. Eklemek için tıklayın.</div>
                    <button type="button" className="btn btn-warning" onClick={handleOpenAddCourseModal}>Kurs Ekle</button>
                </div>
            )}

            {userEducationals.length > 0 && (
                <div className="alert alert-info" role="alert">
                    <strong>Bilgi:</strong> Üyenin {userEducationals.length} aktif eğitim bilgisi vardır.
                    <br /><br />
                    <button type="button" className="btn btn-warning" onClick={handleOpenAddCourseModal}>Yeni Kurs Ekle</button>
                </div>
            )}

            <div style={{ textAlign: "center" }}>
                <h1>Eğitim bilgisi güncelle</h1>
            </div>

            {userInfo && (
                <div className="mb-3">
                    <h5>Kullanıcı: {userInfo?.fullName} - {userInfo?.username}</h5>
                </div>
            )}

            {msg && <h4>{msg}</h4>}

            {loading && <div className="text-center my-4"><h5>Veriler yükleniyor...</h5></div>}

            {/* Alt Formları Map Ederek Basma */}
            {!loading && userEducationals && userEducationals.map((edu, index) => (
                <SingleEducationalForm
                    key={edu.id || index}
                    educational={edu}
                    courses={courses}
                    allsubjects={allsubjects}
                    userId={params['id']}
                    userToken={user.token}
                    t={t}
                    toPlainOptionLabel={toPlainOptionLabel}
                />
            ))}

            {/* Modal Bileşeni */}
            <AddCourseModal
                show={showAddCourseModal}
                onClose={() => setShowAddCourseModal(false)}
                courses={courses}
                userId={params['id']}
                userToken={user.token}
                t={t}
                toPlainOptionLabel={toPlainOptionLabel}
            />
        </div>
    );
};

export default AdminEditUserEducational;